<template>
    <div class="input-group" :style="fieldStyles(input_mask)">
      <field-icon :fieldData="fieldData"></field-icon>

      <the-mask
      :ref="fieldData.field_name"
      :disabled="(!!showDisabled())"
      :aria-describedby="`${fieldData.field_name}_describedby`"
      name="phone_masked"
      type="tel"
      :id="fieldData.field_name"
      v-model="phone_masked_input_value"
      :mask="input_mask"
      :placeholder="fieldData.placeholder"
      @blur.native="apiRule.present && apiRule.type == 'onblur' ? postRule($event.target.value, fieldData) :  ''"
      v-bind:class="{'form-control': true, 'error': errors.has(fieldData.field_name) || fieldData.has_error}">
      </the-mask>

      <input
      :disabled="(!!showDisabled())"
      v-show="false"
      :name="fieldData.field_name"
      type="text"
      class="form-control"
      :maxlength="fieldData.max_length"
      v-model="phone_masked_input_value"
      v-validate="field_rules">
      <span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name)  || fieldData.has_error }"></span>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import FieldIcon from '../presentational/FieldIcon';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  directives: { mask },
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  mixins: [inputFieldMixin],
  props: ['fieldData', 'inputType', 'sendPostRule'],
  data() {
    return {
      field_rules: { required: false }, // Default rule for input validation
      phone_masked_input: '', // Holds the phone masked input value outside of the computed property to avoid an infinite loop
      input_mask: '###-###-####', // TODO: Use config value
    };
  },
  components: { FieldIcon },
  computed: {
    /**
     * Uses data property `masked_input` to store the input field's value without masked characters
     * added. A separate property needs to be used otherwise the computed property would keep updating
     * itself and end up in an infinite loop!
     */
    phone_masked_input_value: {
      get() {
        return this.phone_masked_input;
      },
      set(newValue) {
        this.phone_masked_input = newValue;
        this.fieldData.field_value = this.phone_masked_input;
      },
    },
  },
  mounted() {
    this.phone_masked_input = this.fieldData.field_value; // Populate input value with its form data
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputPhone.vue?6af5e9a0